const HUGFIG_STYLE_OPTION_NAMES = new Set(['Choose Your Style', 'Choose Figure Type', 'Figure Type']);

function hugfigGenerationClassForStyle(style) {
  const normalized = String(style || '').toLowerCase().replace(/\s+/g, ' ');
  if (normalized.includes('person') && normalized.includes('pet')) return 'HUMAN_1_PET_1';
  if ((normalized.includes('2') || normalized.includes('two')) && normalized.includes('pet')) return 'PET_2';
  if (normalized.includes('pet')) return 'PET_1';
  if ((normalized.includes('2') || normalized.includes('two')) && normalized.includes('people')) {
    return normalized.includes('together') ? 'HUMAN_2_TOGETHER' : 'HUMAN_2_SEPARATE';
  }
  if ((normalized.includes('1') || normalized.includes('one')) && normalized.includes('person')) {
    return 'HUMAN_1';
  }
  return '';
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.form.addEventListener('hugfig:generation-state-change', (event) => {
          if (event.detail?.complete) this.handleErrorMessage();
        });
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText =
          this.submitButton.querySelector('.product-form__submit-text') ||
          this.submitButton.querySelector('span:not(.hugfig-add-to-cart-icon)') ||
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      submitHugfigDestination(destination) {
        if (!['cart', 'checkout'].includes(destination) || !this.form?.isConnected) return false;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return false;

        if (destination === 'cart') {
          this.form.dataset.hugfigCartRequested = 'true';
          delete this.form.dataset.hugfigCheckoutRequested;
        } else {
          this.form.dataset.hugfigCheckoutRequested = 'true';
          delete this.form.dataset.hugfigCartRequested;
        }

        try {
          const submitter = this.submitButton.form === this.form ? this.submitButton : undefined;
          this.form.requestSubmit(submitter);
          return true;
        } catch (error) {
          delete this.form.dataset.hugfigCheckoutRequested;
          delete this.form.dataset.hugfigCartRequested;
          console.error('Unable to start the HugFig cart submission.', error);
          return false;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const checkoutRequested =
          this.form.dataset.hugfigCheckoutRequested === 'true' ||
          evt.submitter?.dataset.hugfigCheckout === 'true';
        const cartRequested =
          this.form.dataset.hugfigCartRequested === 'true' ||
          evt.submitter?.dataset.hugfigCart === 'true';
        delete this.form.dataset.hugfigCheckoutRequested;
        delete this.form.dataset.hugfigCartRequested;

        const keychainConfirmationComplete = this.form.dataset.hugfigKeychainConfirmationComplete === 'true';
        delete this.form.dataset.hugfigKeychainConfirmationComplete;

        if (!keychainConfirmationComplete && this.shouldConfirmKeychainSelection()) {
          const destination = checkoutRequested ? 'checkout' : 'cart';
          const confirmationOpened = window.HugfigKeychainAddon?.requestConfirmation?.({
            destination,
            trigger: evt.submitter || this.submitButton,
            continueSubmission: () => {
              this.form.dataset.hugfigKeychainConfirmationComplete = 'true';
              this.form.dataset[destination === 'checkout' ? 'hugfigCheckoutRequested' : 'hugfigCartRequested'] = 'true';
              this.form.requestSubmit(this.submitButton);
            },
          });
          if (confirmationOpened) return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          window.HugfigKeychainAddon?.submissionFailed?.('This product is not available right now. Please try again.');
          if (checkoutRequested) {
            this.form.dispatchEvent(new CustomEvent('hugfig:checkout-failed'));
          }
          if (cartRequested) {
            this.form.dispatchEvent(new CustomEvent('hugfig:cart-failed'));
          }
          return;
        }

        if (!this.validateHugfigGeneration()) {
          window.HugfigKeychainAddon?.submissionFailed?.(
            'Please confirm that the generated preview matches your selected figure type.'
          );
          if (checkoutRequested) {
            this.form.dispatchEvent(new CustomEvent('hugfig:checkout-failed'));
          }
          if (cartRequested) {
            this.form.dispatchEvent(new CustomEvent('hugfig:cart-failed'));
          }
          return;
        }

        const destinationSubmitButton = checkoutRequested
          ? document.getElementById('hugfig-btn-checkout')
          : cartRequested
            ? document.getElementById('hugfig-btn-cart')
            : null;
        let destinationSucceeded = false;
        if (destinationSubmitButton) destinationSubmitButton.disabled = true;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const generatedImageValue = String(formData.get('properties[Uploaded Image]') || '').trim();
        const journeyType = generatedImageValue ? 'ai_preview' : 'standard_product';
        let configSessionId = String(formData.get('properties[_HugFig Config Session ID]') || '').trim();
        if (generatedImageValue && window.HugfigAnalytics?.getConfigSessionId) {
          configSessionId = window.HugfigAnalytics.getConfigSessionId();
          formData.set(
            'properties[_HugFig Config Session ID]',
            configSessionId
          );
          formData.set(
            'properties[_HugFig Source Entry]',
            window.HugfigAnalytics.getSourceEntry?.() || 'product_page'
          );
        }
        const selectedSize = Array.from(this.form.elements || []).find(
          (element) => element.checked && element.dataset?.optionName === 'Size'
        );
        if (selectedSize?.value) formData.set('properties[Size]', selectedSize.value);
        if (variantId) formData.set('properties[_Selected Variant ID]', String(variantId));

        // Gather existing Gift-ready accessories without changing their current
        // one-per-submit quantity behavior.
        const accessoryItems = [];
        const bundleContainer = document.getElementById('HugfigGiftReadyBundle');
        if (bundleContainer) {
          const checkboxes = bundleContainer.querySelectorAll('.hugfig-gift-ready-bundle__checkbox:checked');
          checkboxes.forEach(cb => {
            const varId = cb.getAttribute('data-variant-id');
            if (varId) {
              accessoryItems.push({ id: varId, quantity: 1, properties: {} });
            }
          });
        }

        // The keychain state is shared by the inline card and preview modal.
        // Add it to the same Shopify request so the main figurine and every
        // selected accessory either succeed or fail together.
        const selectedKeychain = window.HugfigKeychainAddon?.getSelectedItem?.();
        if (selectedKeychain?.variantId) {
          formData.set('properties[Keychain]', selectedKeychain.styleName);
          accessoryItems.push({
            id: selectedKeychain.variantId,
            quantity,
            properties: {
              '_HugFig Add-on Type': 'keychain',
              '_HugFig Parent Session ID': configSessionId,
              '_HugFig Config Session ID': configSessionId,
            },
          });
        }

        if (accessoryItems.length > 0) {
          const newFormData = new FormData();
          let itemIndex = 0;

          // Copy main product fields into items[0] array structure
          for (let [key, value] of formData.entries()) {
            if (key === 'id') {
              newFormData.append(`items[${itemIndex}][id]`, value);
            } else if (key === 'quantity') {
              newFormData.append(`items[${itemIndex}][quantity]`, value);
            } else if (key.startsWith('properties[')) {
              const propName = key.substring(11, key.length - 1);
              newFormData.append(`items[${itemIndex}][properties][${propName}]`, value);
            } else {
              // Copy other helper fields (sections, sections_url, etc.)
              newFormData.append(key, value);
            }
          }

          // Append each selected accessory with its own quantity and optional
          // hidden production-linking properties.
          accessoryItems.forEach((accessory) => {
            itemIndex++;
            newFormData.append(`items[${itemIndex}][id]`, accessory.id);
            newFormData.append(`items[${itemIndex}][quantity]`, accessory.quantity);
            Object.entries(accessory.properties).forEach(([name, value]) => {
              if (value) newFormData.append(`items[${itemIndex}][properties][${name}]`, value);
            });
          });

          config.body = newFormData;
        } else {
          config.body = formData;
        }

        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              window.HugfigKeychainAddon?.submissionFailed?.(
                response.description || response.message || 'Unable to add this selection. Please try again.'
              );
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // Normalize response for multi-item additions to prevent cart drawer/notification JS crashes
            if (response.items && response.items.length > 0) {
              response.id = response.items[0].id;
              response.key = response.items[0].key;
              response.title = response.items[0].title;
            }

            window.HugfigAnalytics?.track?.('add_to_cart_context', {
              journey_type: journeyType,
              has_generated_preview: Boolean(generatedImageValue),
              variant_id: String(variantId || ''),
              quantity
            });

            if (checkoutRequested) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              destinationSucceeded = true;
              window.HugfigKeychainAddon?.submissionSucceeded?.();
              window.HugfigAnalytics?.track?.('checkout_handoff', {
                journey_type: journeyType,
                has_generated_preview: Boolean(generatedImageValue),
                variant_id: String(variantId || ''),
                quantity
              });
              window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
              return;
            }

            if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              destinationSucceeded = cartRequested;
              if (cartRequested) {
                window.HugfigKeychainAddon?.submissionSucceeded?.();
                document.dispatchEvent(new CustomEvent('hugfig:cart-succeeded'));
              }
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);
            destinationSucceeded = cartRequested;
            if (cartRequested) {
              window.HugfigKeychainAddon?.submissionSucceeded?.();
              document.dispatchEvent(new CustomEvent('hugfig:cart-succeeded'));
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            window.HugfigKeychainAddon?.submissionFailed?.(e.message || 'Network error. Please try again.');
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            if (checkoutRequested && !destinationSucceeded) {
              this.form.dispatchEvent(new CustomEvent('hugfig:checkout-failed'));
            }
            if (cartRequested && !destinationSucceeded) {
              this.form.dispatchEvent(new CustomEvent('hugfig:cart-failed'));
            }
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      validateHugfigGeneration() {
        const generationField = Array.from(this.form.elements || []).find(
          (element) => element.name === 'properties[Uploaded Image]'
        );
        if (!generationField) return true;

        if (generationField.value.trim()) {
          const generatedClassField = Array.from(this.form.elements || []).find(
            (element) => element.name === 'properties[_Generation Class]'
          );
          const generatedFamilyField = Array.from(this.form.elements || []).find(
            (element) => element.name === 'properties[_Generation Product Family]'
          );
          const selectedStyle = Array.from(this.form.elements || []).find(
            (element) =>
              element.checked &&
              HUGFIG_STYLE_OPTION_NAMES.has(element.dataset?.optionName)
          );
          const expectedClass = hugfigGenerationClassForStyle(selectedStyle?.value);
          const expectedFamily = this.closest('product-info')
            ?.querySelector('variant-selects[data-product-handle]')
            ?.dataset.productHandle || '';
          const classMatches = Boolean(
            expectedClass && generatedClassField?.value === expectedClass
          );
          const familyMatches = Boolean(
            expectedFamily && generatedFamilyField?.value === expectedFamily
          );

          if (classMatches && familyMatches) return true;

          const mismatchMessage =
            'This preview was generated for a different figure type. Select the matching option or generate a preview for the current selection.';
          this.handleErrorMessage(mismatchMessage);
          this.dispatchCartErrorEvent(mismatchMessage, 'VALIDATION_CUSTOM');
          generationField.closest('.hugfig-uploader-container')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
          return false;
        }

        const message = 'Please upload your photo and finish generating the preview before adding to cart.';
        this.handleErrorMessage(message);
        this.dispatchCartErrorEvent(message, 'VALIDATION_CUSTOM');

        const uploader = generationField.closest('.hugfig-uploader-container');
        if (uploader) {
          uploader.classList.add('has-validation-error');
          uploader.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(() => uploader.classList.remove('has-validation-error'), 2400);
        }

        return false;
      }

      shouldConfirmKeychainSelection() {
        return this.closest('product-info')?.dataset.hugfigKeychainConfirmation === 'true';
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = text || window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
